module.exports = __webpack_public_path__ + "media/images/common/side_hr-257c0a83f233de86562ddece8a11f895.gif";